import React,{Component} from 'react';
import { autobind } from 'core-decorators';
import { observer } from 'mobx-react';

import './TotalView.less'
@observer
class TotalView extends Component{

    constructor(prop){
        super(prop);
    }

    
    @autobind
    renderItem(){

        const {model} = this.props;
        return model.totalAmount.map((item, i)=>{
            return (
                <div style={item.weight} key={i}>
                    <span className='titleGray' dangerouslySetInnerHTML={{__html: item.title}}></span>
                    <span className='titleGray'>{item.title?'：':''}</span>
                    <span style={item.style}>{item.value}</span>
                </div>
            );
        });
    }

    render(){

        return (
            <div className='totalView'>
                {this.renderItem()}
            </div>
        );
    }
}
export default TotalView;